// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from '../../types/fs-core'
import ProviderLogoPlatinum from '../platinum-modules/provider-logo'

interface ProvidersLogoModuleProps {
  name: string
  variant: string
}

const ProvidersLogoModuleWrapper: React.FC<ProvidersLogoModuleProps> = ({
  variant,
  name,
}) => {
  if (variant === 'platinum' || variant === 'cardFinderProviders') {
    return <ProviderLogoPlatinum name={name} variant={variant} />
  }

  // Providers-logo-module-legacy is not functional
  return <React.Fragment />
}

export default connect((state: FsCore.State, props) => {
  // Currently this is broken and not producting lender logo data
  // const providerLogoData = getESProductDataSetData(state, props.dataset.sys.id)?.hits?.hits
  const providerLogoData = undefined
  return {
    ...props,
    providerLogoData,
  }
})(ProvidersLogoModuleWrapper)
